import { List, fromJS } from 'immutable';
import { clearTouristData } from 'src/store/tourists/slice';
import {
  TOURISTS_VALIDATION_FAILED,
  TOURISTS_VALIDATION_SUCCESS,
  TOURIST_VALIDATION_FAILED,
  TOURIST_VALIDATION_SUCCESS,
  VALIDATE_TOURIST_FIELD_SUCCESS,
  VALIDATE_TOURIST_FIELD_FAILED,
} from '../constants/tourists';

const initialState = List();

const removeTouristErrors = (state, idx) =>
  state.filter((error) => !error.path.startsWith(`[${idx}]`));
const removeTouristFieldErrors = (state, idx, field) =>
  state.filter((error) => {
    const [index, fieldName] = error.path.split('.');
    return index !== `[${idx}]` || fieldName !== field;
  });

export default function validationReducer(state = initialState, action) {
  switch (action.type) {
    case TOURIST_VALIDATION_FAILED: {
      const { errors, index } = action.payload;
      const touristErrors = errors?.map((error) => {
        // eslint-disable-next-line no-param-reassign
        error.path = `[${index}].${error.path}`;
        return error;
      });
      return removeTouristErrors(state, index).merge(touristErrors);
    }
    case TOURIST_VALIDATION_SUCCESS: {
      const {
        payload: { index },
      } = action;
      return removeTouristErrors(state, index);
    }
    case VALIDATE_TOURIST_FIELD_SUCCESS: {
      const {
        payload: { index, field },
      } = action;
      return removeTouristFieldErrors(state, index, field);
    }
    case VALIDATE_TOURIST_FIELD_FAILED: {
      const {
        payload: { index, field, error },
      } = action;
      const fieldError = { ...error, path: `[${index}].${field}` };
      return removeTouristFieldErrors(state, index, field).concat(fieldError);
    }
    case TOURISTS_VALIDATION_FAILED:
      return fromJS(action.payload);
    case TOURISTS_VALIDATION_SUCCESS:
      return initialState;
    case clearTouristData.type:
      return initialState;

    default:
      return state;
  }
}
